export default function VPNService() {
  return (
    <section id="vpn-service" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F36] mb-4">
            OUR VPN SERVICE
          </h2>
          <p className="text-xl text-gray-600">
            Enterprise-grade security for your connection
          </p>
        </div>

        <div className="relative bg-white rounded-[50px] shadow-xl overflow-hidden border-4 border-transparent bg-clip-padding">
          <div className="absolute inset-0 rounded-[50px] p-[4px] bg-gradient-to-r from-[#00D4AA] to-[#1A1F36]" style={{ zIndex: -1 }}></div>
          
          <div className="bg-white rounded-[46px] p-8 lg:p-12">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="w-full h-96">
                  <img
                    src="https://public.readdy.ai/ai/img_res/d908c4ff9ddefd4862189ceb139b1986.jpg"
                    alt="VPN Tunnel Illustration"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              <div className="order-1 lg:order-2 space-y-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                      Military-Grade Encryption
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      AES-256 encryption ensures your data remains completely secure and unreadable to third parties
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                      Global Server Network
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      Access servers in multiple countries for optimal speed and unrestricted content access
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-lock-password-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                      Zero-Log Policy
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      We never track, collect, or store your online activities or personal information
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-speed-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                      Lightning-Fast Speed
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      Optimized servers deliver high-speed connections without compromising security
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00D4AA] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-devices-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-[#1A1F36] mb-2">
                      Multi-Device Support
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      Protect all your devices with a single account - desktop, mobile, and tablet
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
